<template>
  <!-- <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <right-panel v-if="showSettings">
        <settings />
      </right-panel>
    </div>
  </div> -->
  <v-app id="inspire">
    <base-nav :items="items"></base-nav>
    <v-main>
      <router-view />
    </v-main>

    <base-footer/>
  </v-app>
</template>

<script>
import { BaseFooter, BaseNav } from './components'
// import RightPanel from '@/components/RightPanel'
// import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
// import { AppMain, Navbar, Sidebar, TagsView } from './components'
// import ResizeMixin from './mixin/ResizeHandler'
// import { mapState } from 'vuex'

export default {
  name: 'EmployerLayout',
  components: {
    BaseFooter,
    BaseNav
    // AppMain,
    // Navbar,
    // RightPanel,
    // Settings,
    // Sidebar,
    // TagsView
  },
  data () {
    return {
    }
  },
  computed: {
    items () {
      return [
        {
          to: '/employer/job-ads',
          icon: 'mdi-post',
          title: this.$t('message.nav.ads')
        },
        {
          to: '/employer/candidate',
          icon: 'mdi-clipboard-account',
          title: this.$t('message.nav.candidate')
        },
        {
          to: '/employer/talent',
          icon: 'mdi-clipboard-text-multiple',
          title: this.$t('message.nav.talent')
        },
        {
          to: '/employer/purchase',
          icon: 'mdi-crown',
          title: this.$t('message.nav.purchase')
        },
        {
          to: '/employer/billing',
          icon: 'mdi-receipt',
          title: this.$t('message.nav.billing')
        },
        {
          to: '/employer/settings',
          icon: 'mdi-account-settings',
          title: this.$t('message.nav.employer_settings')
        },
        {
          to: '/login',
          icon: 'mdi-account-tie',
          title: this.$t('message.nav.seeker')
        },
        {
          to: '/employer-login',
          icon: 'mdi-account-tie',
          title: this.$t('message.nav.employer')
        },
        {
          to: '/org-login',
          icon: 'mdi-account-tie',
          title: this.$t('message.nav.org')
        }
      ]
    }
  }

  // mixins: [ResizeMixin],
  // computed: {
  //   ...mapState({
  //     sidebar: state => state.app.sidebar,
  //     device: state => state.app.device,
  //     showSettings: state => state.settings.showSettings,
  //     needTagsView: state => state.settings.tagsView,
  //     fixedHeader: state => state.settings.fixedHeader
  //   }),
  //   classObj () {
  //     return {
  //       hideSidebar: !this.sidebar.opened,
  //       openSidebar: this.sidebar.opened,
  //       withoutAnimation: this.sidebar.withoutAnimation,
  //       mobile: this.device === 'mobile'
  //     }
  //   }
  // },
  // methods: {
  //   handleClickOutside () {
  //     this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
  //   }
  // }
}
</script>
